import React from "react";
import Hero from "./sections/Hero/Hero";
import Stats from "./sections/Stats/Stats";
import Services from "./sections/Services/Services";
import Why from "./sections/Why/Why";
import Testimonials from "./sections/Testimonials/Testimonials";
import Process from "./sections/Process/Process";
import Impact from "./sections/Impact/Impact";
import FAQ from "./sections/FAQ/FAQ";
import BookingFlow from "../Contact/sections/BookingFlow/BookingFlow";
import LogoTicker from "../../components/ui/LogoTicker/LogoTicker";
import "./Home.css";

const Home = ({ ready }) => {
  return (
    <div className="home">
      <Hero ready={ready} />
      <Stats />
      <Services />
      <Why />
      <LogoTicker />
      <Testimonials />
      <Process />
      <Impact />
      <FAQ />
      <BookingFlow />
    </div>
  );
};

export default Home;
